import { EmailCampaign } from '@spike/email-marketing-model';

/**
 * Human-readable audience label for a sent campaign. Unlike the wizard's own
 * `humanizeCriteria` (which reads form values), this helper works off the raw
 * `criteria` + `criteriaArgs` fields on the persisted campaign, joining tag
 * ids against the marketplace's positive tag master data.
 *
 * Falls back to "All Clients" when no criteria was captured — the wizard's
 * default recipient mode is All Clients, and legacy campaigns from before the
 * criteria field was populated should read as such.
 */
export const humanizeCriteria = (
    campaign: EmailCampaign,
    positiveTags: Array<{ id: string; name: string }>
): string => {
    if (!campaign.criteria || campaign.criteria === 'all') {
        return 'All Clients';
    }

    if (campaign.criteria === 'by_tag') {
        const ids = (campaign.criteriaArgs ?? '')
            .split(',')
            .map(part => part.trim())
            .filter(Boolean);
        const names = ids
            .map(id => positiveTags.find(tag => tag.id === id)?.name)
            .filter((name): name is string => Boolean(name));
        if (names.length === 0) return 'By Client Tag';
        return `By Client Tag (${names.join(', ')})`;
    }

    // Post-MVP criteria (by_date_added / by_activity / by_pet_type) fall through
    // to a neutral placeholder — the criteria filters are hidden in the wizard
    // today, but campaigns created before that hide could still exist in the
    // wild with these values.
    return '—';
};
